export default "__VITE_ASSET__W3jKA1tf__"